import { useEffect } from 'react';
import { trackUserInit } from './events';
import { useAccount } from '../../account';

const useUserInit = () => {
  const { accessToken } = useAccount();
  useEffect(() => {
    trackUserInit({ isLoggedIn: !!accessToken });
  }, [accessToken]);
};

export { useUserInit };
